import React from 'react';
import './Footer.css';
import { FaFacebookF, FaWhatsapp, FaInstagram } from 'react-icons/fa';

function Footer() {
  return (
    <footer className="footer">
        <p> <a href="mailto:example@example.com"> nadavbzv3@gmail.com </a> :טלפון:  0543203500 | צור קשר</p>
        <div className="social-icons">
          <a href="https://wa.me/message/4CRSU4NUHIXPI1" className="social-icon" aria-label="WhatsApp" target="_blank" rel="noopener noreferrer">
              <FaWhatsapp />
          </a>
          <a href="https://www.facebook.com/share/Yu7QxWnF5zq5CRDf/?mibextid=qi2Omg" className="social-icon" aria-label="Facebook" target="_blank" rel="noopener noreferrer">
              <FaFacebookF />
          </a>
          <a href="https://www.instagram.com/compassionate_communication_bs?igsh=YzM1bGlpdjV2bXFn" className="social-icon" aria-label="Instagram" target="_blank" rel="noopener noreferrer">
              <FaInstagram />
          </a>
        </div>
        <p>&copy; Amir Malamud
        </p>
    </footer>
  );
}

export default Footer;
